import { useAuth0 } from '@auth0/auth0-react'
import { TopBarProvider } from '~components/web-components/top-bar-provider'
import { Box } from '@mui/material'
import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import EarningsValidationRibbon from '~components/earnings-validation-ribbon'
import { StagePreviewRibbon } from '~components/stage-preview-ribbon'
import LoadComponent from '~components/molecules/load-component/load-component'
import { useNavAndFooterConstants } from '../../hooks/use-nav-and-footer-constants'
import ScrollToTop from '../../utils/scroll-to-top'
import { Footer } from './footer/footer'
import { Navigation } from './navigation/navigation'
import { ImpersonationRibbon } from './impersonation-ribbon/impersonation-ribbon'
import { TopNavigationOpenPages } from './navigation/top-navigation/top-navigation-open-pages'
import useBreakpoint from '~hooks/use-breakpoint'

export default function NavigationAndFooter({
  children,
}: {
  children?: ReactNode
}) {
  const { isMobileSize } = useBreakpoint(true)
  const { isAuthenticated, isLoading } = useAuth0()
  const { footerHeight, leftNavigationWidth, topNavigationHeight } =
    useNavAndFooterConstants()
  const location = useLocation()
  const isLandingPage = location.pathname === '/'

  if (isLoading) {
    return <LoadComponent />
  }

  if (!isAuthenticated) {
    return (
      <Box
        sx={{
          position: 'relative',
          minHeight: isMobileSize ? 'auto' : '100vh',
        }}
      >
        <ScrollToTop />
        {!isLandingPage && <TopNavigationOpenPages />}
        <Box
          component="main"
          sx={{
            pb: footerHeight,
          }}
        >
          {children}
        </Box>
        <Footer withOutLeftNav />
      </Box>
    )
  }

  return (
    <Box
      sx={{ position: 'relative', minHeight: isMobileSize ? 'auto' : '100vh' }}
    >
      <ScrollToTop />
      <TopBarProvider>
        <Navigation />
      </TopBarProvider>
      <Box
        component="main"
        sx={{
          width: '100%',
          pb: footerHeight,
          mt: topNavigationHeight,
        }}
      >
        <Box sx={{ ml: leftNavigationWidth }}>{children}</Box>
      </Box>
      <ImpersonationRibbon />
      <EarningsValidationRibbon />
      <StagePreviewRibbon />
      <Footer />
    </Box>
  )
}
